import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
import brands from "../src/Json/Brand.json";
function LibasMenuChildren({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");
  const childrenShoes = [
    {
      name: "Ballet flats",
      params:
        "/products?subcategory=o5MKsloJPSAFqPBcwrC6&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Boots",
      params:
        "/products?subcategory=Ajx4IbmZyd8tDPIUIWq1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "First Shoes",
      params:
        "/products?subcategory=o5MKsloJPSAFqr7itcQ&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Flats",
      params:
        "/products?subcategory=o5MKsloJPSAFqsBcwrC6&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Lace up boots",
      params:
        "/products?subcategory=o5MKsloJPSAFqjwywu4&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Sandals",
      params:
        "/products?subcategory=MUMXw3hjGufq8nrZgCi3&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Slippers",
      params:
        "/products?subcategory=o5MKsloJPSAFqPBcwrC4&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    // {
    //   name: "Trainers",
    //   params:
    //     "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=uw8UHRzTK2qlgU8Y4cVc&",
    //   nameAr: "",
    // },
  ];
  const childrenBagsAcc = [
    {
      name: "Bags & Pencil cases",
      params: "/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Belts Susupenders",
      params:
        "/products?subcategory=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Hats & Gloves",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Scarves",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Sunglasses",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
  ];
  const baby = [
    {
      name: "Outfits",
      params:
        "/products?subcategory=0ldOyc2LDplxjnatowqF&gender=zw8UHRzTK2qlgU8Y4cVc",
      nameAr: "",
    },
    {
      name: "Pajamas & Bodysuits",
      params:
        "/products?subcategory=0Pp9HzoWrvft8UB5D19k&gender=zw8UHRzTK2qlgU8Y4cVc",
      nameAr: "",
    },
    {
      name: "Shoes",
      params: "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=zw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
  ];
  const childboys = [
    {
      name: "Trousers",
      params:
        "/products?subcategory=pA6VRVYknSqqtwfdrtq&id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Boys - Sets",
      params:
        "/products?subcategory=GtwMidaECoB0Y54rDqOg&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
  ];
  const childgirlclothes = [
    {
      name: "Dresses",
      params:
        "/products?subcategory=0ldOyc2LDplxjnFPnpcW&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Girls - Sets",
      params:
        "/products?subcategory=GtwMidaECoB0Y54rDqOg&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Trousers",
      params:
        "/products?subcategory=pA6VRVYknSqqtwfdrtq&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Skirts",
      params:
        "/products?subcategory=TRFN20ugEqoa2YqMCGsc&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
  ];

  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* children */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("children")}
          style={{
            borderBottom:
              expandedCategory === "children" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "children" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "children" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?gender=uw8UHRzTK2qlgU8Y4cVc&"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "children") {
                setHide(true);
                return;
              } else {
                setActiveFilter("children");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "children" ? "500" : "400",
                textDecoration:
                  expandedCategory === "children" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Kids")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "children" ? menuup : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "children" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of children */}
                  <ul className="list-unstyled">
                    {/* clothes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=tTwOQNL4etSBiJy0j5zY&`}
                          className="subtitlemega "
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{
                              marginLeft: "15px",
                            }}
                            onClick={() =>
                              navigateToCategory("children", "clothes")
                            }
                          >
                            {t("Girls clothes")}
                          </motion.button>
                        </Link>
                        {/* Animated arrow for subcategory */}
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("childgirlclothes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.childgirlclothes
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.childgirlclothes
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for childgirlclothes childgirlclothes */}
                      <AnimatePresence>
                        {expandedSubcategories.childgirlclothes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {childgirlclothes?.map((brand) => (
                              <Link
                                key={brand.name}
                                to={brand.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "children") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("children");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "children",
                                        "brand",
                                        brand.slug || brand.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? brand.name
                                      : brand.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/*       {t("Boys clothes")} with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("children", "children")
                            }
                          >
                            {t("Boys clothes")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("childboys");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.childboys ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.childboys
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for childboys */}
                      <AnimatePresence>
                        {expandedSubcategories?.childboys && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {childboys?.map((brand) => (
                              <Link
                                key={brand.name}
                                to={brand.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "children") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("children");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "children",
                                        "brand",
                                        brand.slug || brand.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? brand.name
                                      : brand.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* baby with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?gender=zw8UHRzTK2qlgU8Y4cVc&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("children", "mens")
                            }
                          >
                            {t("Baby")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("baby");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.baby ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.baby ? menudown : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for baby */}
                      <AnimatePresence>
                        {expandedSubcategories?.baby && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {baby?.map((brand) => (
                              <Link
                                key={brand.name}
                                to={brand.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "children") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("children");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "children",
                                        "brand",
                                        brand.slug || brand.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? brand.name
                                      : brand.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* child shoes with nested oiptions */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("children", "mens")
                            }
                          >
                            {t("ChildrenShoes")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("childrenShoes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.childrenShoes
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.childrenShoes
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for childrenShoes */}
                      <AnimatePresence>
                        {expandedSubcategories?.childrenShoes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {childrenShoes?.map((brand) => (
                              <Link
                                key={brand.name}
                                to={brand.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "children") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("children");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "children",
                                        "brand",
                                        brand.slug || brand.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? brand.name
                                      : brand.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                    {/* bags and acc with nested menus */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to="/products?id=AqFLulu9y2m4mqEIkch1&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() =>
                              navigateToCategory("children", "mens")
                            }
                          >
                            {t("BagsAccessories")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("childrenBagsAcc");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.childrenBagsAcc
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.childrenBagsAcc
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for childrenBagsAcc */}
                      <AnimatePresence>
                        {expandedSubcategories?.childrenBagsAcc && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {childrenBagsAcc?.map((brand) => (
                              <Link
                                key={brand.name}
                                to={brand.params}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "children") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("children");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "children",
                                        "brand",
                                        brand.slug || brand.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? brand.name
                                      : brand.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuChildren;
